<template>
  <div class="service_box safe-distance-top-header-two">
    <Header :pageTitle="$route.meta.title" />
    <keep-alive :include="keepAlive">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
export default {
  name: "Partner",
  components: {
    Header,
  },
  data() {
    return {
      keepAlive: ["PartnerServiceForm"],
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        // 如果是从b到a页面，则不缓存b
        // 注意 路由那么要与组件name一致
        if (from) {
          if (
            from.name === "PartnerServiceForm" &&
            to.name !== "PartnerAgreementPage"
          ) {
            this.keepAlive = [""];
          } else {
            this.keepAlive = ["PartnerServiceForm"];
          }
        }
      },
      immediate: true,
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.service_box {
  min-height: 100vh;
  // background-color: #f5f5f5;
}
</style>
